import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { JwtUtils } from '../utils/jwt.utils';
import { SignIn } from '../../services/auth-api/models/index';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(public router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    // Guard for user is login or not
    let singInReponse: SignIn | undefined = localStorage.getItem(
      'singInReponse'
    )
      ? JSON.parse(localStorage.getItem('singInReponse') ?? '')
      : null;

    if (!singInReponse || JwtUtils.isTokenExpired(singInReponse.accessToken)) {
      this.router.navigate(['/auth/login']);
      return false;
    }

    return true;
  }
}
